import PropTypes from 'prop-types';
import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import NavigationBlocker from './NavigationBlocker';

const NavigationBlockerContext = createContext(null);

export const NavigationBlockerProvider = ({ children }) => {
    const [isBlocking, setIsBlocking] = useState(false);
    const [onNavigate, setOnNavigate] = useState(null);

    const register = useCallback((blocking, navigateCallback) => {
        setIsBlocking(blocking);
        setOnNavigate(() => navigateCallback);
    }, []);

    const unregister = useCallback(() => {
        setIsBlocking(false);
        setOnNavigate(null);
    }, []);

    const value = useMemo(() => ({ register, unregister }), [register, unregister]);

    return (
        <NavigationBlockerContext.Provider value={value}>
            {children}
            <NavigationBlocker isBlocking={isBlocking} onNavigate={onNavigate || undefined} />
        </NavigationBlockerContext.Provider>
    );
};

NavigationBlockerProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export const useNavigationBlocker = (isBlocking, onNavigate) => {
    const context = useContext(NavigationBlockerContext);

    useEffect(() => {
        if (!context) return undefined;

        context.register(isBlocking, onNavigate);

        return () => context.unregister();
    }, [context, isBlocking, onNavigate]);
};
